import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import "../assets/CSS/Dashboard.css";

export default function BOMdata() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [records, setRecords] = useState([]);
  const [loadingRecords, setLoadingRecords] = useState(false);

  const toggleSidebar = () => setIsSidebarVisible((v) => !v);

 const fetchRecords = async () => {
  setLoadingRecords(true);
  try {
    const resp = await axiosInstance.get("/api/Tall-Bom/UniqueLOTID");
    setRecords(resp.data.lotRecords || []);
  } catch (err) {
    console.error("Error loading BOM records:", err);
  } finally {
    setLoadingRecords(false);
  }
};


  useEffect(() => {
    fetchRecords();
  }, []);

  const handleUpload = async (Voucher_Number) => {
  try {
    await axiosInstance.patch(`/api/update-status/${Voucher_Number}`, {
      Status: "Uploaded",
    });
    alert("Status updated successfully.");
    fetchRecords(); // Refresh data
   
  } catch (err) {
    console.error("Failed to update status:", err);
    alert("Failed to update status.");
  }
};


const handleExport = async (Voucher_Number) => {
  try {
    const res = await axiosInstance.get(`/api/bom/export/${Voucher_Number}`, {
      responseType: "blob"
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `BOM_${Voucher_Number}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (err) {
    console.error("Export failed:", err);
    alert("Export failed.");
  }
};


  const columns = [
    {
      name: "Voucher Number",
      selector: (row) => row.Voucher_Number,
      sortable: true,
    },     
     {
      name: "Uploaded At",
      selector: (row) => row.UploadedAt || "N/A",
      sortable: true,
    },
    {
      name: "File Name",
      selector: (row) => row.FileName || "N/A",
      sortable: true,
    },
     {
      name: "Uploaded By",
      selector: (row) => row.UploadedBy || "N/A",
      sortable: true,
    },
  //    {
  //   name: "Uploaded", width: "200px",
  //   cell: (row) => (
  //     <button
  //       className={`btn btn-sm ${row.Status === "Pending" ? "btn-danger" : "btn-success"}`}
  //       onClick={() => handleUpload(row.Voucher_Number)}
  //     >
  //       {row.Status === "No" ? "Not Uploaded" : "Uploaded"}
  //     </button>
  //   ),
  //   ignoreRowClick: true,
  //   allowOverflow: true,
  //   button: true,
  // },
   {
    name: "Uploaded", width: "200px",
    cell: (row) => (
      <button
        className={`btn btn-sm ${row.Status === "Pending" ? "btn-danger" : "btn-success"}`}
        onClick={() => row.Status === "Pending" && handleUpload(row.Voucher_Number)}
        disabled={row.Status !== "Pending"}  // 🔒 Disable if already uploaded
      >
        {row.Status === "Pending" ? "Not Uploaded" : "Uploaded"}
      </button>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  {
  name: "Export", width: "150px",
  cell: (row) => (
    <button
      className="btn btn-outline-dark btn-sm"
      onClick={() => handleExport(row.Voucher_Number)}
    >
      Export Excel
    </button>
  ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  ];

  return (
    <div className="d-flex dashboard">
      <div
        className={
          isSidebarVisible ? "sidebar-container" : "sidebar-hidden"
        }
      >
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />
        <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
          <div id="alertPlaceholder" />
          <h3 className="mb-4">BOM Verification</h3>

          {loadingRecords ? (
            <div className="text-center">
              <span className="spinner-border" /> Loading...
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={records}
              pagination
              highlightOnHover
              striped
            />
          )}
        </main>
      </div>
    </div>
  );
}
